import React, { useEffect, useState } from "react";
import { getOrgUserDetails, getOrgDetails } from "../../services/CommonService";
import ListOfUsers from "./ListOfUsers";
import dropdown from "../../assets/Icons/dropdown.svg";
import {
  getDashboardUsers,
  getPopulationData,
} from "../../services/DashboardServices";
import PopulationDataChart from "../../components/Common/PopulationDataChart/PopulationDataChart";
import ListOfAllReport from "./ListOfAllReport";
import { useOrgContext } from "../../Context/orgContext";
import { CircularProgress } from "@mui/material";
import { Link } from 'react-router-dom';
import Header from "../../components/Header/Header";
import LinkIcon from '@mui/icons-material/Link';
import { useClientDetailsContext } from "../../Context/ClientDetails";

const DashBoard = () => {
  const [pageMetaData, setPageMetaData] = useState({}); //{page: 0, total_pages: 0, total_records: 0, per_page: 0}
  const [page, setPage] = useState(0);
  const [orgname, setOrgname] = useState("");
  const [populationData, setPopulationData] = useState([]);
  const [populationDataLegend, setPopulationDataLegend] = useState([]);
  const [uniqueUsers, setUniqueUsers] = useState({}); //{jan: 1, feb: 1, mar: 1, apr: 1, may: 2, …}
  const [showAllUsers, setShowAllUsers] = useState(false);
  const currentYear = new Date().getFullYear();
  const [ graphYear, setGraphYear ] = useState(currentYear);
  const [ graphLoading, setGraphLoading ] = useState(false);
  const { setOrgDetials, setIsOrgAdmin, isOrgAdmin } = useOrgContext();
  const [ showCopiedText , setShowCopiedText ] = useState(false);
  const { allClinicsData , setAllClinicsData, selectedClinicCode , setSelectedClinicCode } = useClientDetailsContext();

  const getSelectedClinicAssessmentLink = () => {
    const selectedClinic = allClinicsData.filter( clinic => clinic.clinic_code === selectedClinicCode )?.[0];
    return selectedClinic?.clinic_assessment_link
  }

  useEffect(() => {
    getOrgDetails().then((res) => {
      if (res) {
        setOrgDetials(JSON.parse(res));
        if (JSON.parse(res)?.dashboard_config?.user_table_req) {
          setShowAllUsers(true);
        } else {
          setShowAllUsers(false);
        }
        setOrgname(JSON.parse(res).organisation_name);
      }
    });
    if( allClinicsData.length === 0 ){
      getOrgUserDetails().then( res => {
        setIsOrgAdmin(res.permission);
        setAllClinicsData(res.clinics);
      });
    }
  }, []);

  useEffect(() => {
    getDashboardUsers({page, selectedClinicCode}).then((res) => {
      setPageMetaData(res.data);
    });
  } , [ selectedClinicCode, page ])

  const handleRefresh = () => {
    setGraphLoading(true);
    getPopulationData({ graphYear, selectedClinicCode }).then((res) => {
      const chartData =
        res.population_analytics[0].body_part_exercise_analytics.map((item) => {
          return {
            name: item.body_part_name,
            values: item.exercise_analytics,
            color: item.color_code,
          };
        });
      setUniqueUsers(res.unique_users_each_month);
      setPopulationData(chartData);
      setPopulationDataLegend(
        res.population_analytics[0].body_part_exercise_analytics
      );
    });
    setGraphLoading(false);
    setPageMetaData({})
    getDashboardUsers({page , selectedClinicCode }).then((res) => {
      setPageMetaData(res.data);
    });
  };

  useEffect(() => {
    console.log('changedInFilter')
    setGraphLoading(true);
    getPopulationData({graphYear , selectedClinicCode }).then((res) => {
      const chartData =
        res.population_analytics[0].body_part_exercise_analytics.map((item) => {
          return {
            name: item.body_part_name,
            values: item.exercise_analytics,
            color: item.color_code,
          };
        });
      setUniqueUsers(res.unique_users_each_month);
      setPopulationData(chartData);
      setPopulationDataLegend(
        res.population_analytics[0].body_part_exercise_analytics
      );
    });
    setGraphLoading(false);
  }, [ graphYear, selectedClinicCode ]);

  const copiedHandler = () => {
    setShowCopiedText(true);
    navigator.clipboard.writeText(getSelectedClinicAssessmentLink());
    setTimeout(() => setShowCopiedText(false) , 2000);
  }

  const getClientNameBySelectedClinicId = () => {
    const clientName = allClinicsData.filter( ele => ele.clinic_code === selectedClinicCode )?.[0]?.clinic_name;
    return clientName ? clientName : "All";
  }

  return (
    <div className="max-w-[1440px] mx-auto pb-[4rem] bg-[#F5F9FF]">
      <Header />
      <div className="max-w-[1280px] mx-auto my-0">
        { isOrgAdmin && <div className="mt-8 flex justify-end">
          <div className="flex gap-4 justify-center items-center">
            <div className="text-[1.1rem]">Select Client: </div>
            <select
              value={selectedClinicCode}
              name=""
              id=""
              className="outline-none rounded appearance-none px-6 py-2 cursor-pointer"
              style={{
                border: "1px solid #E1E5EB",
                backgroundImage: `url(${dropdown})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "20px",
                paddingRight: "30px",
              }}
              onChange={(e) => {
                setSelectedClinicCode(e.target.value);
              }}
            >
              <option value="">All</option>
              {
                allClinicsData && allClinicsData.length > 0 &&
                allClinicsData.map( clinicData => <option value={clinicData.clinic_code} key={clinicData.clinic_id}>{clinicData.clinic_name}</option>)
              }
            </select>
          </div>
        </div>}
        <div className={`${ isOrgAdmin ? "" : "mt-16" } border-b border-solid border-b-[#DADFFF] text-[#000000] text-xl font-semibold leading-[30px] pb-[10px] pl-1`}>
          {
            orgname === "ATI"
            ? `${getClientNameBySelectedClinicId()} Reports`
            : `${orgname} Reports`
          }
        </div>
        { selectedClinicCode !== "" && 
          <div className="flex justify-between items-center px-[1rem] bg-[#fff] rounded-md mt-[1rem] px-[1rem] py-[1rem]">
            <div className="flex gap-2">
              <div className="text-[#415280] font-semibold"> {getClientNameBySelectedClinicId()} Assessment Link:</div>
              <Link to={getSelectedClinicAssessmentLink()} target="_blank" rel="noopener noreferrer" className="text-[blue] underline">{getSelectedClinicAssessmentLink()}</Link>
            </div>
            <div className="bg-[#F5F9FF] border border-1 py-[4px] px-[6px] rounded-md cursor-pointer relative">
              <div className="rotate-45" onClick={() => copiedHandler()}><LinkIcon sx={{ color: '#000'}} /></div>
              { showCopiedText && <div className="absolute bottom-[125%] left-[-65%]">
                <div className="relative">
                  <div className="px-[1rem] py-[0.5rem] text-[#415280] rounded-md bg-[#E1EDFF]">Copied!</div>
                  <div className="w-[15px] h-[15px] bg-[#E1EDFF] rotate-45 absolute bottom-[-10%] left-[50%] translate-x-[-50%]"></div>
                </div>
              </div>}
            </div>
          </div>
        }
        <div className="flex justify-between gap-6 mt-10 mb-12">
          <div className="w-[410px] h-[120px] rounded-xl border border-solid border-[#EAECF0] bg-[#FFFFFF] p-6">
            <div className="mb-2 font-medium text-base leading-5 text-[#475467]">
              New Reports
            </div>
            <div className="flex justify-between items-center">
              <div className="text-4xl leading-[44px] text-[#101828] font-semibold">
                {pageMetaData && pageMetaData.new_reports_count}
              </div>
            </div>
          </div>
          <div className="w-[410px] h-[120px] rounded-xl border border-solid border-[#EAECF0] bg-[#FFFFFF] p-6">
            <div className="mb-2 font-medium text-base leading-5 text-[#475467]">
              Total Reports
            </div>
            <div className="flex justify-between items-center">
              <div className="text-4xl leading-[44px] text-[#101828] font-semibold">
                {pageMetaData && pageMetaData.total_reports_count}
              </div>
            </div>
          </div>
          <div className="w-[410px] h-[120px] rounded-xl border border-solid border-[#EAECF0] bg-[#FFFFFF] p-6">
            <div className="mb-2 font-medium text-base leading-5 text-[#475467]">
              Total Users
            </div>
            <div className="flex justify-between items-center">
              <div className="text-4xl leading-[44px] text-[#101828] font-semibold">
                {pageMetaData && pageMetaData.total_user_count}
              </div>
            </div>
          </div>
        </div>
        {/* {showAllUsers ? (
          <>
            <div className="flex justify-start mb-4 text-black text-lg font-semibold">
              Population data
            </div>
            <div
              className="
          pt-10
          py-[50px]
          px-7
          mb-10
        rounded-xl
        bg-[#FFFFFF]
        "
              style={{
                boxShadow: "0px 4px 2px 0px rgba(16, 24, 40, 0.06)",
                border: "1px solid #EAECF0",
              }}
            >
              <div
                className="flex items-center justify-between pb-4"
                style={{
                  borderBottom: "1px solid #DDD",
                }}
              >
                <div className="flex items-center">
                  <div className="text-base text-[#415280]">
                    X-axis : <span className="font-medium">Months</span>
                  </div>
                  &nbsp;
                  <div className="text-base text-[#415280]">
                    Y-axis :{" "}
                    <span className="font-medium">
                      Improvement Opportunity Level
                    </span>
                  </div>
                </div>
                <div className="flex justify-end gap-4">
                  {populationDataLegend.map((item, index) => {
                    return (
                      <div key={index}>
                        <div className="flex justify-between items-center">
                          <div className="flex items-center">
                            <div
                              className="w-6 h-2 rounded-[4px] mr-[8px]"
                              style={{ backgroundColor: item.color_code }}
                              // style={{ backgroundColor: "#FF0000" }}
                            ></div>
                            <div className="text-[#475467] text-base leading-[30px]">
                              {item.body_part_name}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="w-full flex justify-end">
                <select
                  className="outline-none rounded appearance-none px-3 py-2 mt-6 mr-6 cursor-pointer"
                  style={{
                    border: "1px solid #E1E5EB",
                    backgroundImage: `url(${dropdown})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 10px center",
                    backgroundSize: "20px",
                    paddingRight: "30px",
                  }}
                  value={graphYear}
                  onChange={(e) => {
                    setGraphYear(e.target.value);
                  }}
                >
                  <option value={2025} className="cursor-pointer">
                    2025
                  </option>
                  <option value={2024} className="cursor-pointer">
                    2024
                  </option>
                  <option value={2023} className="cursor-pointer">
                    2023
                  </option>
                </select>
              </div>
              { populationData && populationData?.length > 0 ? (
                <PopulationDataChart
                  data={populationData}
                  uniqueUsers={uniqueUsers}
                />
              ) : graphLoading ? <CircularProgress /> : ''}
            </div>
          </>
        ) : null} */}
        {
          showAllUsers 
          ? <ListOfUsers handleRefresh={handleRefresh} clinicId={selectedClinicCode} />
          : <ListOfAllReport clinicId={selectedClinicCode} />
        }
      </div>
    </div>
  );
};

export default DashBoard;
